import { EmbeddedMessage, WhatsApp } from 'constants/messageMediums';
import { MessageMedium } from 'modules/graphql/types';
import { useMemo } from 'react';

import { PreviewPane as EmailPreviewPane } from '../../EditEmail/preview/PreviewPane';
import { PreviewPane as EmbeddedPreviewPane } from '../../EditEmbedded/preview/PreviewPane';
import { PreviewPane as InAppPreviewPane } from '../../EditInApp/preview/PreviewPane';
import { PreviewPane as PushPreviewPane } from '../../EditPush/preview/PreviewPane';
import { PreviewPane as SMSPreviewPane } from '../../EditSMS/preview/PreviewPane';
import { PreviewPane as WebPushPreviewPane } from '../../EditWebPush/preview/PreviewPane';
import { PreviewPane as WhatsAppPreviewPane } from '../../EditWhatsApp/preview/PreviewPane';

import { useTemplateQueryContext } from '../../context/TemplateQueryContext';

type TemplatePreviewComponentType = {
  [mesageMediumKey in MessageMedium]?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
};

const mediumViews: TemplatePreviewComponentType = {
  [MessageMedium.SMS]: SMSPreviewPane,
  [MessageMedium.Push]: PushPreviewPane,
  [MessageMedium.WebPush]: WebPushPreviewPane,
  [MessageMedium.Email]: EmailPreviewPane,
  [MessageMedium.InApp]: InAppPreviewPane,
  [EmbeddedMessage]: EmbeddedPreviewPane,
  [WhatsApp]: WhatsAppPreviewPane,
};

export const getPreviewComponents = (medium: MessageMedium) => mediumViews?.[medium];

export const useTemplatePreview = (): React.FunctionComponent<React.PropsWithChildren<unknown>> => {
  const { medium } = useTemplateQueryContext();
  const loadPreview = useMemo(
    () => getPreviewComponents(medium as MessageMedium),
    [medium],
  ) as React.FunctionComponent<React.PropsWithChildren<unknown>>;
  return loadPreview;
};
